module.exports = __webpack_public_path__ + "static/img/asan-dc1.bb69b7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/asan-dc1.jpg
// module id = 6DiZ
// module chunks = 0